module.exports = __webpack_public_path__ + "img/logo-transparent.653b2378.png";